import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useSubmitFeedback from '../../../../hooks/dashboard/BaDriverVerification/useSubmitFeedback';
import {
  FeedbackDataType,
  FeedbackInitialValues,
  FeedbackSchema,
} from '../../../../models/dashboard/ba-verification/feedback';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextAreaInputField } from '../../../FormCom/FormField';
import { TableContext } from '../../../Table/TableContext';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';

interface ComplaintViewSubmissionFormProps {
  data: any;
}
const ComplaintViewSubmissionForm: React.FC<
  ComplaintViewSubmissionFormProps
> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);
  const { resetSliderIndex, sliderIndex } = useContext(
    TranslatingContainerContext,
  )!;
  const { submitFeedback, loading } = useSubmitFeedback();

  const onSubmit = (values: FeedbackDataType) => {
    submitFeedback(values, data?.id ?? '', () => {
      modalContext?.setShowModal(false);
      tableContext?.setRefreshTable(!tableContext?.refreshTable);
      resetSliderIndex();
    });
  };
  return (
    <Container className={sliderIndex < 2 ? 'inactive' : ''}>
      <Item>
        <ItemLabel>Reason for Rejection</ItemLabel>
        <ItemValue>{data?.rejectionReason ?? 'N/A'}</ItemValue>
      </Item>

      <Item>
        <ItemLabel>Customer Complaint</ItemLabel>
        <ItemValue>{data?.complaint ?? 'N/A'}</ItemValue>
      </Item>

      <FormComponent
        initialValues={FeedbackInitialValues}
        schema={FeedbackSchema}
        onSubmit={onSubmit}
        className={'small-gap'}
      >
        <StyleLabel>
          <TextAreaInputField
            label='Send Feedback'
            name='feedback'
            id='feedback'
            type='text'
            placeholder='Type message here'
          />
        </StyleLabel>

        <FormSubmitButton className='blue topMargin large' loading={loading}>
          Submit
        </FormSubmitButton>
      </FormComponent>
    </Container>
  );
};

export default ComplaintViewSubmissionForm;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  padding: 16px;

  &.inactive > * {
    display: none;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ItemLabel = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #4b5563;
`;

const ItemValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background: #f5f5f5;
  border-radius: 4px;
  padding: 10px 16px;
`;

const StyleLabel = styled.div`
  label {
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    color: #4b5563;
  }
`;
